import type { SessionResponse } from '@schemas/session'
import type { ReactNode } from 'react'
import { useRouteLoaderData } from 'react-router'
import { AccessDenied } from '../components/error-pages/access-denied.tsx'
import { canManage } from '../lib/can-manage.ts'

export interface AdminOnlyProps {
  surface: string
  belongsToAdmin: string
  children: ReactNode
}

// The route-level half of rule 3: a member's nav never offers these, but a link, a bookmark or a
// back button still can. The API is the real gate (requireWorkspaceAdmin) — this turns what would
// be a bare 403 into board D's refusal.
export function AdminOnly({ surface, belongsToAdmin, children }: AdminOnlyProps) {
  const session = useRouteLoaderData('root') as SessionResponse | undefined
  if (canManage(session)) return <>{children}</>
  return <AccessDenied session={session as SessionResponse} surface={surface} belongsToAdmin={belongsToAdmin} />
}
